import {
  ActivityItem,
  Checkbox,
  CommandBarButton,
  Facepile,
  IActivityItemProps,
  IComboBox,
  IComboBoxOption,
  IContextualMenuProps,
  IFacepilePersona,
  IIconProps,
  Label,
  Link,
  Panel,
  PanelType,
  Persona,
  PersonaPresence,
  PersonaSize,
  Stack,
  divProperties,
  mergeStyleSets,
} from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import {
  IAsignarRol,
  IItemCheckboxBaseDTO,
  IItemComboRolesDTO,
  IUserById,
} from "../../../Interfaces/IUsuario";
import usuarioServicio from "../../../services/usuarioService";
import axios from "axios";
import { IException } from "../../../Interfaces/base/IBase";

interface IPanelAsignacionRoles {
  isOpen: boolean;
  onDismiss: () => void;
  usuarioId: string | undefined;
  onRenderTable: () => void;
  roles: string[];
  identityId: string | undefined;
  nombre: string;
  email: string;
}
export const PanelAsignacionRoles = (props: IPanelAsignacionRoles) => {
  const addIcon: IIconProps = { iconName: "Contact" };
  const [form, setForm] = useState<IAsignarRol>({
    identityId: props.identityId,
    rol: [],
  });
  const [rolesCombo, setRolesCombo] = useState<IItemCheckboxBaseDTO[]>([]);

  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      dataRoles();
    }
  }, [props.isOpen]);

  function dataRoles() {
    usuarioServicio
      .allRol()
      .then((res: any) => {
        if (res.status == 200) {
          var data: IItemComboRolesDTO[] = res.data;
          var newData: IItemCheckboxBaseDTO[] = data.map((x) => ({
            key: x.key,
            text: x.text,
            isChecked: false,
          }));
          if (props.roles?.length > 0) {
            props.roles.map((d) => {
              var newRol: IItemCheckboxBaseDTO = newData.find(
                (x) => x.key === d
              )!;

              if (newRol) {
                var listaRoles = newData.filter((x) => x.key != d);
                var rol: IItemCheckboxBaseDTO = {
                  key: newRol.key,
                  text: newRol.text,
                  isChecked: true,
                };
                setForm({ ...form, rol: [...form.rol!, newRol.key] });

                newData = [rol, ...listaRoles];
              }
            });
          }

          setRolesCombo(newData);
        }
      })
      .catch((e: IException) => {
        console.log(e.response.data.errors);
      });
  }

  useEffect(() => {
    let IDs: string[] = [];
    rolesCombo.forEach((item) => {
      if (item.isChecked) {
        IDs.push(item.key);
      }
    });
    setForm({ ...form, rol: IDs });
  }, [rolesCombo]);

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="ContactInfo"
          subTextHeader="Crear un nuevo rol para usuario"
          textHeader="Nuevo Rol"
        />
      </>
    ),
    []
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Asignar Rol"
          texto2={"Salir"}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            setRolesCombo([]);
            setForm({ ...form, rol: [] });
            setIsSend(false);
            setIsSaccesfull(false);
            props.onDismiss();
          }}
        />
      </>
    ),
    [props.onDismiss, form]
  );

  const handleCheckboxChange = (index) => {
    const roles = [...rolesCombo];
    roles[index].isChecked = !roles[index].isChecked;
    setRolesCombo(roles);
  };

  const _confirmar = () => {
    setIsSend(true);
    if (form) {
      usuarioServicio
        .asignarRolByUser(form)
        .then((res) => {
          if (res.status === 200) {
            setIsSend(false);
            setIsSaccesfull(true);
            props.onRenderTable();
            setRolesCombo([]);
            setForm({ ...form, rol: [] });
            props.onDismiss();
          }
        })
        .catch((err: Error) => {
          alert(err.message);
        });
    }
  };

  const limpiarResponse = () => {
    setRolesCombo([]);
    setForm({ ...form, rol: [] });
    setIsSend(false);
    setIsSaccesfull(false);
    props.onDismiss();
  };
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={limpiarResponse}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
      isLightDismiss={true}
    >
      <>
        <br />
        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: "Registro Exitoso", codigoMensaje: 1 }}
          />
        )}

        {isSend}
        {<IdicadorProgress subText="Registrando Datos" isSend={isSend} />}

        {/* <pre>{JSON.stringify(dataUser, null, 2)}</pre> */}
        <Persona
          text={props.nombre}
          secondaryText={props.email}
          size={PersonaSize.size40}
          hidePersonaDetails={false}
          imageAlt="Annie Lindqvist, status is away"
          presence={PersonaPresence.online}
        />

        <div
          style={{
            width: "100%",
            // border: "solid 1px red",
            marginTop: "20px",
            position: "relative",
          }}
        >
          <CommandBarButton
            style={{
              margin: "auto",
              //   border: "solid 1px green",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
            iconProps={addIcon}
            text="Roles Asignados"
            disabled={false}
            checked={false}
          />
        </div>
        <br />
        <br />

        <Stack styles={{ root: { height: "55vh", overflow: "scroll" } }}>
          <>
            {rolesCombo.map((item, index) => (
              <div style={{ marginBottom: "5px" }}>
                <Checkbox
                  key={index}
                  label={item.text}
                  checked={item.isChecked}
                  //   onChange={onChange}
                  onChange={(ev, data) => handleCheckboxChange(index)}
                />
              </div>
            ))}
          </>
        </Stack>

        {/*  <pre>{JSON.stringify(objRegistrar, null, 2)}</pre> */}
      </>
    </Panel>
  );
};
